module.exports = __webpack_public_path__ + "img/box6-04.fe3ca5c9.png";